const AP_REF_TGA_DOSAGE_FORM_TYPES = [
  'capsule',
  'herb_dried',
  'extract',
  'extract_concentrated',
  'inhalation',
  'oral_liquid',
  'pastille',
  'pessary',
  'inhalation_pressurised',
  'suppository',
  'topical',
  'wafer',
];

const AP_CATEGORIES = AP_REF_TGA_DOSAGE_FORM_TYPES.flatMap((type) =>
  Array.from({ length: 5 }, (_, index) => `${type}_category_${index + 1}`),
);

export { AP_REF_TGA_DOSAGE_FORM_TYPES as AP_TYPES, AP_CATEGORIES };
